import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import styles from './Typography.module.sass'

const Typography = ({
  tag: Tag, classes, weight, align, font, fontStyle, children, ...other
}) => {
  const moreStyles = {
    textAlign: align,
  }

  const defaultClasses = {
    [styles.typography]: true,
    [styles[`font-${font}`]]: true,
    [styles[`weight-${weight}`]]: true,
    [styles[Tag]]: true,
    [styles[`font-style-${fontStyle}`]]: true,
  }

  return <Tag className={cn(defaultClasses, classes)} style={moreStyles} {...other}>{children}</Tag>
}

Typography.defaultProps = {
  tag: 'p',
  classes: '',
  weight: 'inherit',
  fontStyle: 'inherit',
  align: 'left',
  font: 'inherit',
  onClick: () => { },
}

Typography.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]).isRequired,
  tag: PropTypes.string,
  font: PropTypes.oneOf(['inherit', 'avenir']),
  weight: PropTypes.oneOf([
    'normal',
    'bold',
    'bolder',
    'lighter',
    'initial',
    'inherit',
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
  ]),
  fontStyle: PropTypes.oneOf(['normal', 'italic', 'oblique', 'initial', 'inherit']),
  align: PropTypes.string,
  classes: PropTypes.string,
  onClick: PropTypes.func,
}

export default Typography
